
export default {
  backgroundImage: require(`@/assets/map/background-mobile.png`),
};
